<svg id="chart" class="chart" preserveAspectRatio="xMidYMid meet" overflow="scroll">
  <defs>
    <!-- MILLIMETER PAPER PATTERN -->
    <pattern id="paper" x="0" y="0" width="10" height="10" patternUnits="userSpaceOnUse">
      <line x1="0" y1="0" x2="0" y2="10" stroke="red" stroke-width="0.5" />
      <line x1="1" y1="0" x2="1.0001" y2="10" stroke="red" stroke-width="0.1" [attr.transform]="'translate(0.1, 0)'" />
      <line x1="2" y1="0" x2="2.0001" y2="10" stroke="red" stroke-width="0.1" [attr.transform]="'translate(0.1, 0)'" />
      <line x1="3" y1="0" x2="3.0001" y2="10" stroke="red" stroke-width="0.1" [attr.transform]="'translate(0.1, 0)'" />
      <line x1="4" y1="0" x2="4.0001" y2="10" stroke="red" stroke-width="0.1" [attr.transform]="'translate(0.1, 0)'" />

      <line x1="5" y1="0" x2="5.0001" y2="10" stroke="red" stroke-width="0.2" [attr.transform]="'translate(0.1, 0)'" />
      <line x1="6" y1="0" x2="6.0001" y2="10" stroke="red" stroke-width="0.1" [attr.transform]="'translate(0.1, 0)'" />
      <line x1="7" y1="0" x2="7.0001" y2="10" stroke="red" stroke-width="0.1" [attr.transform]="'translate(0.1, 0)'" />
      <line x1="8" y1="0" x2="8.0001" y2="10" stroke="red" stroke-width="0.1" [attr.transform]="'translate(0.1, 0)'" />
      <line x1="9" y1="0" x2="9.0001" y2="10" stroke="red" stroke-width="0.1" [attr.transform]="'translate(0.1, 0)'" />

      <line x1="0" y1="0" x2="10" y2="0" stroke="red" stroke-width="0.5" />
      <line x1="0" y1="1" x2="10" y2="1.0001" stroke="red" stroke-width="0.1" [attr.transform]="'translate(0, 0.1)'" />
      <line x1="0" y1="2" x2="10" y2="2.0001" stroke="red" stroke-width="0.1" [attr.transform]="'translate(0, 0.1)'" />
      <line x1="0" y1="3" x2="10" y2="3.0001" stroke="red" stroke-width="0.1" [attr.transform]="'translate(0, 0.1)'" />
      <line x1="0" y1="4" x2="10" y2="4.0001" stroke="red" stroke-width="0.1" [attr.transform]="'translate(0, 0.1)'" />

      <line x1="0" y1="5" x2="10" y2="5.0001" stroke="red" stroke-width="0.2" [attr.transform]="'translate(0, 0.1)'" />
      <line x1="0" y1="6" x2="10" y2="6.0001" stroke="red" stroke-width="0.1" [attr.transform]="'translate(0, 0.1)'" />
      <line x1="0" y1="7" x2="10" y2="7.0001" stroke="red" stroke-width="0.1" [attr.transform]="'translate(0, 0.1)'" />
      <line x1="0" y1="8" x2="10" y2="8.0001" stroke="red" stroke-width="0.1" [attr.transform]="'translate(0, 0.1)'" />
      <line x1="0" y1="9" x2="10" y2="9.0001" stroke="red" stroke-width="0.1" [attr.transform]="'translate(0, 0.1)'" />
    </pattern>
  </defs>

  <g id="chartRoot" [attr.transform]="chart?.transform">

    <rect x="0" fill="url(#paper)" width="100%" height="100%" [attr.opacity]="chart?.opacity"></rect>

    <g #centering layers-centering [hideWhileCentering]="hideWhileCentering">
      <g chart-layer *ngFor="let layer of chart?.layers"
        [arrangement]="arrangement$ | async"
        [layer]="layer"
        (layoutChange)="centering.centerLayers()"></g>
    </g>
  </g>

  <text x="50%" y="15" class="chart-title">{{title}}</text>

</svg>
